import React, { Component, useState, useEffect } from 'react';
import HeaderComponent from './partials/HeaderComponent';
import FooterComponent from './partials/FooterComponent';
import { Redirect, Link as RouterLink } from 'react-router-dom';
import "./css/contestDesc.css";
import axios from 'axios';
import { connect } from 'react-redux';
import { LOGIN, LOGOUT } from '../Pages/ReduxStore/slices/authSlice';
import Spinner from '../Pages/MerchandiseStore/Spinner/Spinner';
import { Nav, NavItem, Modal, ModalBody, NavLink, TabContent, TabPane, Form, FormGroup, Label, Input, FormFeedback } from "reactstrap";
import CoinImg from "../assets/img/coin.png";
import parse from 'html-react-parser';

class ContestDesc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registerState: "none",
      responseData: {},
      isModalOpen: false,
      referral: "",
      registerError: "",
      firstName: "",
      lastName: "",
      email: "",
      loading: false,
      currTime: "",
      contestData: {
        contest_description: "",
        contest_rules:"",
        contest_prizes:"",
        contest_eligibilty: "",
        codeforces_link: "",
      }
    }
    this.setRegisterState = this.setRegisterState.bind(this);
    this.setResponseData = this.setResponseData.bind(this);
  }
  setRegisterState = (val) => { this.setState({ registerState: val }) };
  setResponseData = (val) => { this.setState({ responseData: val }) };
  async componentDidMount() {
    this.setState({ loading: true });
    // this.isPaid();
    await axios.post(`https://server.codeium.tech/contest/paid/transaction`, {
      "username": this.props.username,
      "contest_id": this.props.match.params.contestId
    }).then(res => {
      // console.log("contestDesc: ", res);
      if (res.data.status === 200) {
        // console.log(res.data);
        this.setRegisterState(res.data.msg["ispaid"]);
        this.setResponseData(res.data.msg);
        // console.log(this.state.responseData);
      }
      else {
        // console.log(res);
      }
    }).catch(err => {
      // console.log(err);
    })
    if (this.props.username) {
      await axios.post('https://server.codeium.tech/user/profile', {
        username: this.props.username
      }).then(res => {
        // console.log(res);
        const userInfo = res.data.msg[0];
        this.setState({
          firstName: userInfo.fname,
          lastName: userInfo.lname,
          email: userInfo.email_id
        })
      })
    }
    await axios.get('https://server.codeium.tech/contest/details',
      {
        params: {
          "contest_id": this.props.match.params.contestId,
        }
      }
    ).then(res => {
      // console.log(res.data.msg[0]);
      this.setState({ contestData: res.data.msg[0] });
      // console.log("Current : "+new Date(res.data.time).toLocaleString());
    }).catch(err => {
      // console.log(err);
    })

    await axios.get('https://server.codeium.tech/time').then(res => {
      this.setState({ currTime: new Date(res.data.time).getTime() });
      // console.log("Current : "+new Date(res.data.time).toLocaleString());
    }).catch(err => {
      // console.log(err);
    })
    this.setState({ loading: false });
  }

  getProfile = () => {
    axios.post('https://server.codeium.tech/user/profile', {
      username: this.props.username
    }).then(res => {
      // console.log(res);
      const userInfo = res.data.msg[0];
      this.setState({
        firstName: userInfo.fname,
        lastName: userInfo.lname,
        email: userInfo.email_id
      })
    })
  }
  toggleModal = () => { this.setState({ isModalOpen: !this.state.isModalOpen }); }
  onRefferalChange = (event) => {
    const target = event.target;
    const value = (target.type === 'checkbox') ? target.checked : target.value;
    this.setState({
      referral: value
    });
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.state.responseData) === "{}") {
      this.isPaid();
    }
    if (prevProps.username !== this.props.username && this.props.username) {
      // console.log(this.props.username);
      this.getProfile();
    }
  }
  isPaid = async () => {
    try {
      const res = await axios.post(`https://server.codeium.tech/contest/paid/transaction`, {
        "username": this.props.username,
        "contest_id": this.props.match.params.contestId
      });
      if (res.data.status === 200) {
        // console.log(res.data);
        this.setRegisterState(res.data.msg["ispaid"]);
        this.setResponseData(res.data.msg);
        // console.log(this.state.responseData);
      }
      else {
        // console.log(res);
      }
    } catch (err) {
      // console.log(err);
    }
  };
  registerNow = () => {
    const sendPostRequest = async () => {
      try {
        const payload = this.state.contestData.codeforces_link.length === 0 ? {
          "username": this.props.username,
          "email_id": this.state.email,
          "contest_id": this.props.match.params.contestId,
          "contest_name": this.props.contest.contest_name,
        } : {
          "username": this.props.username,
          "email_id": this.state.email,
          "contest_id": this.props.match.params.contestId,
          "contest_name": this.props.contest.contest_name,
          "referral": this.state.referral
        }
        const res = await axios.post(`https://server.codeium.tech/contest/register`, {
          ...payload
        });
        if (res.data.status === 200) {
          // console.log(res);
          this.setRegisterState("none");
          this.isPaid();
          if (this.state.isModalOpen) {
            this.setState({ isModalOpen: false });
          }
        }
        else {
          // console.log(res);
          this.setState({ registerError: "Error : Please try again Later!!" });
        }
      } catch (err) {
        // console.log(err);
        this.setState({ registerError: "Error : Please try again Later!!" });
      }
    };
    sendPostRequest();
    
    // if (!triggerModal)
    // this.toggleModal();
  }
  render() {

    const contestId = this.props.match.params.contestId;
    const contest_name = (this.props.contest) ? this.props.contest.contest_name : "Fantasy League";
    const ContestButton = () => {
      let currTime = this.state.currTime;
      let endTime = (this.props.contest) ? new Date(this.props.contest.end_time).getTime() : null;
      // console.log("Start Time : "+new Date(this.props.contest.start_time).toLocaleString());
      // console.log("End Time : "+new Date(this.props.contest.end_time).toLocaleString());
      // console.log("Difference : " + ((currTime - endTime)) / 36e5);
      if (endTime && (currTime - endTime) / 36e5 >= 1) {
        let url = `/contests/${contestId.trim()}/problems`;
        if (contestId.includes('cf')) {
          url = `/contests/${contestId.trim()}/problems/leaderboard`
        } 
        return (
          <div className="">
            <RouterLink to={url} className="btn btn-custom-dark">
              Practice
            </RouterLink>
          </div>
        );
      }
      else if (endTime && ((currTime - endTime)) / 36e5 >= 0) {
        return (
          <div className="">
            <button className="btn btn-custom-dark" disabled>
              Practice
            </button>
          </div>
        );
      }
      else if (this.state.registerState == null || this.state.registerState == "Failure") {
        return (
          <form name="f1" action="https://securegw.paytm.in/theia/processTransaction">
            {
              Object.keys(this.state.responseData).map(inputKey => {
                return <input key={inputKey} readOnly type="hidden" name={inputKey} value={this.state.responseData[inputKey]} />
              })
            }
            <button type="submit" className="btn btn-custom-dark bg-warning">Pay Now</button>
          </form>
        );
      }
      else if (this.state.registerState == "Success") {
        var now = new Date();
        var startTime = new Date(this.props.contest.start_time);
        if (now > startTime) {
          let url = `/contests/${contestId.trim()}/problems`;
          if (contestId.includes('cf')) {
            url = this.state.contestData.codeforces_link;
          }
          return (
            <>
            {
              contestId.includes('cf') ? <a className="btn btn-custom-dark" href={this.state.contestData.codeforces_link} target="_blank" >
              Start Now  
              </a> : <RouterLink to={url} className="btn btn-custom-dark">
              Start Now
            </RouterLink>
            }
            </>
            )   
        }
        else {
          return (
            <button className="btn btn-custom-dark" disabled>
              Start Now
            </button>
          );
        }
      }
      return (<button onClick={() => {
        if (this.state.contestData.codeforces_link) {
          // this.toggleModal();
          this.setState({ isModalOpen : true });
        } else {
          this.registerNow();
        }
      }}  className="btn btn-custom-dark"> Register Now</button>);
    }
    try {
      if (this.props.contest) {
        return (
          <div className="">
            <HeaderComponent />
            {(this.state.loading) ? <Spinner /> :
              <div className="page-wrapper">
                <div className="jumbotron p-0 pt-4 text-center" style={{ maxHeight: "500px", background: "inherit" }}>
                  <div className="overlay">
                    <div className="pt-5 pt-md-4">
                      <h1 className="primary-heading animation-heading m-0 p-0">{contest_name}</h1>
                    </div>
                    <div className="animation-text">
                      Date : {new Date(this.props.contest.start_time).toLocaleString([], { year: 'numeric', month: 'short', day: '2-digit' })}
                    </div>
                    <div className="animation-text">
                      Time : {new Date(this.props.contest.start_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} to {new Date(this.props.contest.end_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </div>
                  </div>
                  <video className="d-none d-sm-block" width="100%" autoPlay loop>
                    <source src="/assets/img/animations/Plain-animation-desktop.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <video className="d-block d-sm-none" width="100%" autoPlay loop>
                    <source src="/assets/img/animations/Plain-animation-mobile.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <h1 className="primary-heading">{contest_name} </h1>
                    </div>
                  </div>
                  <div className="row d-flex justify-content-start align-items-center ">
                    <div className="col-10 col-md-3 py-2 py-md-0">
                      <span className="field"><b>STARTS : </b></span>
                      <span className="details">
                        {new Date(this.props.contest.start_time).toLocaleString([], { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>
                    <div className="col-6 col-md-2 py-2 py-md-0">
                      <span className="field"><b>ENDS : </b></span>
                      <span className="details">
                        {new Date(this.props.contest.end_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>
                    <div className="col-6 col-md-2 py-2 py-md-0">
                      <span className="field"><b>COINS POOL :</b></span>
                      <span className="details"> {this.props.contest.contest_coins}
                        <img src={CoinImg} className="Cart_CoinImg" />
                      </span>
                    </div>
                    {/* <div className="col-6 col-md-2 py-2 py-md-0">
                      <span className="field"><b>PRICE :</b></span><span className="details"> <strike className="text-muted">₹50</strike> <span style={{ fontSize: '18px' }}>₹0</span> </span>
                    </div> */}
                    <div className="col-6 col-md-2 py-2 py-md-0 pr-0">
                      <ContestButton />
                    </div>
                    <div className="col-12">
                      <hr width="100%" />
                    </div>
                  </div>
                  <div className="py-2">
                    <h4><b>Contest Description</b></h4>
                    {parse(this.state.contestData.contest_description)}
                  </div>
                  <div className="py-2">
                    <h4><b>Rules and Regulations :</b></h4>
                    {parse(this.state.contestData.contest_rules)}
                  </div>
                  <div className="py-2">
                    <h4><b>Prizes :</b></h4>
                    {parse(this.state.contestData.contest_prizes)}
                  </div>
                  <div className="py-2">
                    <h4><b>Eligibility Criteria :</b></h4>
                    {parse(this.state.contestData.contest_eligibilty)}
                  </div>
                  <div className="row d-flex justify-content-center align-items-center py-2">
                    <ContestButton />
                  </div>
                </div>
                <br />
              </div>
            }
            <FooterComponent />
            <Modal id="loginSignUp" isOpen={this.state.isModalOpen} toggle={this.toggleModal} className="login">
              <ModalBody className="auth-inner pt-5">
                <FormGroup>
                  <h4 className="pb-0px pt-2 primary-heading text-center"
                    style={{ fontSize: "40px", color: "#444444" }}
                  >Register Now</h4>
                </FormGroup>
                <FormGroup>
                  <Label className="font-weight-bold">Name</Label>
                  <Input type="text" name="username" className="form-control" value={this.state.firstName + " " + this.state.lastName} disabled />
                </FormGroup>
                <FormGroup>
                  <Label className="font-weight-bold">Username</Label>
                  <Input type="text" name="username" className="form-control" value={JSON.parse(localStorage.getItem('Codeium__Username'))} disabled />
                </FormGroup>
                <FormGroup>
                  <Label className="font-weight-bold">Email Address</Label>
                  <Input type="text" name="username" className="form-control" value={this.state.email} disabled />
                </FormGroup>
                {
                  this.state.contestData.codeforces_link && <FormGroup>
                  <Label className="font-weight-bold">Codeforces handle *</Label>
                  <Input type="text" id="referral" name="referral" className="form-control" required placeholder="Codeforces handle *" value={this.state.referral} onChange={this.onRefferalChange} />
                </FormGroup>
                }
                <FormGroup>
                  <FormFeedback className="d-block">{this.state.registerError}</FormFeedback>
                </FormGroup>
                <button onClick={this.registerNow} className="btn btn-custom-dark btn-block">Register</button>
                {/* </Form> */}
              </ModalBody>
            </Modal>
          </div>
        );
      }
      else {
        return (
          <Redirect to="/contests" />
        );
      }
    }
    catch {
      return (
        <Redirect to="/404Page" />
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    username: state.auth.username,
    isAuthenticated: state.auth.isAuthenticated
  }
}

const mapDispatchToProps = dispatch => {
  return {
    reduxLogin: (username) => dispatch(LOGIN(username)),
    reduxLogout: () => dispatch(LOGOUT())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContestDesc);